import { useCallback } from 'react';

import useLocalStorage from '~/hooks/useLocalStorage';

export const SECTION_NAVIGATION_STORAGE_KEY = 'adminSectionNavigation';

export const SECTION_NAVIGATION_MODES = {
  HEADER: 'header',
  SIDEBAR: 'sidebar',
} as const;

export type SectionNavigationMode = (typeof SECTION_NAVIGATION_MODES)[keyof typeof SECTION_NAVIGATION_MODES];

/** In-page sections use the Find a section sidebar unless you choose header tabs. */
const DEFAULT_SECTION_NAVIGATION_MODE = SECTION_NAVIGATION_MODES.SIDEBAR;

export function isSectionNavigationMode(value: unknown): value is SectionNavigationMode {
  return value === SECTION_NAVIGATION_MODES.HEADER || value === SECTION_NAVIGATION_MODES.SIDEBAR;
}

export default function useSectionNavigationPreference() {
  const [storedMode, setStoredMode] = useLocalStorage(SECTION_NAVIGATION_STORAGE_KEY, DEFAULT_SECTION_NAVIGATION_MODE);
  const sectionNavigationMode = isSectionNavigationMode(storedMode) ? storedMode : DEFAULT_SECTION_NAVIGATION_MODE;

  const setSectionNavigationMode = useCallback(
    (mode: SectionNavigationMode) => {
      setStoredMode(mode);
    },
    [setStoredMode],
  );

  return [sectionNavigationMode, setSectionNavigationMode] as const;
}
